import script from "./StoreRole.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreRole.vue?vue&type=script&setup=true&lang=js"

import "./StoreRole.vue?vue&type=style&index=0&id=3f8b1536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8b1536"]])

export default __exports__